import {Detail} from "./Detail";

export class Causale extends Detail {
  id: number;
  codice: string;
  descrizione: string;
  organizzazioneId: number;
  tipoCausale: number;
  isActive: boolean;
}
